import Typography from '@mui/material/Typography'
import { IntlShape, useIntl } from 'react-intl'
import { isFiniteNumber } from '../../utils/utils'

export const centsToEur = (cents: number) =>
  Number.parseFloat((cents / 100).toFixed(2))
export const eurToCents = (eur: number) => Math.round(eur * 100)

export const formatPrettyCurrency = (parameters: {
  intl: IntlShape
  cents?: number
}) => {
  return isFiniteNumber(parameters.cents)
    ? parameters.intl.formatNumber(centsToEur(parameters.cents), {
        style: 'currency',
        currency: 'EUR',
      })
    : null
}

const PrettyCurrency = (props: { cents?: number }) => {
  const intl = useIntl()
  return (
    <Typography>
      {formatPrettyCurrency({ intl, cents: props.cents })}
    </Typography>
  )
}

export default PrettyCurrency
